import { getProjectName } from "helpers/_helpers";
import Fuse from 'fuse.js';

export const getStatusColor = (sheet) => {
  if (sheet.canceledAt) return '#D14646';
  if (sheet.verificationStatus === 'verified') return '#0C842B';
  if (sheet.verificationStatus === 'pending') return '#3E82FF';
  if (sheet.submitted || sheet.submittedAt) return '#3E82FF';
  if (sheet.published) return '#979797';
  return '#D14646';
}

export const getStatusText = (sheet) => {
  if (sheet.canceledAt) return 'Canceled';
  if (sheet.verificationStatus === 'verified') return 'Verified';
  if (sheet.verificationStatus === 'pending') return 'Pending Verification'
  if (sheet.submitted || sheet.submittedAt) return 'Submitted';
  if (sheet.published) return 'Published';
  return 'Draft';
}

export const getStatusLetter = (sheet) => {
  if (sheet.canceledAt) return 'C';
  if (sheet.verificationStatus === 'verified') return 'V';
  if (sheet.verificationStatus === 'pending') return 'PV'
  if (sheet.submitted || sheet.submittedAt) return 'S';
  if (sheet.published) return 'P';
  return 'D';
}


export const getSheetEventTitle = (sheet, titleLength, subJobNumber) => {
  const projectName = getProjectName(sheet.project);
  const projectCounty = sheet.project.county ? `, ${sheet.project.county}` : '';
  const title = projectName + projectCounty;

  const jobNumberLength = 14;
  const maxLineLength = 21;
  // for cl view, for grid view on condition submitted && hiddenResources
  const maxLines = titleLength === 'short'
    ? 2
    : titleLength === 'cropped' ? 4 : Infinity;
  const titleLines = Math.ceil(title.length / maxLineLength);

  let length = (maxLines * maxLineLength);
  if (subJobNumber) length -= jobNumberLength;
  
  return title.length > length
    ? title.slice(0, length - 4).trim() + '...'
    : title;
}

export const getEventSheetsFuse = (allSheets) => {
  return new Fuse(allSheets, {
    threshold: 0.1,
    keys: [
      'title',
      'project.contractor.name',
      'project.jobNumber',
      'workers.username',
      'equipment.name',
      'equipment.number',
    ]
  });
}
